<span *ngIf="loadingStyle === 'Dots'">
  {{data}} &nbsp;
  <span class="loader__dot text-primary">.</span>
  <span class="loader__dot text-primary">.</span>
  <span class="loader__dot text-primary">.</span>
  <span class="loader__dot text-primary">.</span>
</span>
